import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export const fncPopulateVendors = ({ commit, dispatch, state, rootState }, payload) => {
	if (state.vendorList == '' || (payload != undefined && payload.reload == true) || (payload != undefined && payload.refresh == true)) {
		var objAuth = JSON.parse(rootState.objAuthorize);
		var vendorDetails = { a: 'getAll', manufacturer: objAuth.manufacturer };
		Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php', { params: vendorDetails }, rootState.headerDetails)
			.then(response => {
				return response.json();
			}, error => {
				console.log(error);
			}).then(data => {
				commit('fncSetVendors', data);
			});
	}
};

export const fncPopulateVendorsCsv = ({ commit, dispatch, state, rootState }, payload) => {
    var objAuth = JSON.parse(rootState.objAuthorize);
    var vendorDetails = { a: 'getAll' };
    Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php', { params: vendorDetails }, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        console.log(error);
      }).then(data => {

        var departmentDetails = { manu_id: objAuth.manufacturer };
        Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Department.php?a=retrieve', departmentDetails, rootState.headerDetails)
          .then(response => {
            return response.json();
          }, error => {
            console.log(error);
          }).then(dd => {

            // setup the article code assoc obj
            var pcLinks = [];
            for( var n in dd ) {
              if( dd[n].product_codes.length > 0 ) {
                for( var c in dd[n].product_codes ) {
                  if( dd[n].product_codes[c].value != '' ) {
                    pcLinks[dd[n].product_codes[c].value] = dd[n].name;
                  }
                }
              }
            }

          if( data.length > 0 ) {

            var exportData = [];
            var exportHeaders = ['VENDOR NAME', 'DEPARTMENT', 'RANGE', 'ARTICLE CODE', 'VENDOR ID'];
            exportData.push(exportHeaders)
            for( var d in data ) {
              // ranges
              if( data[d].ranges.length > 0 ) {
                for( var dr in data[d].ranges ) {
                  if( data[d].ranges[dr].val != '' ) {
                    var subData = [data[d].name, 'N/A', data[d].ranges[dr].range_name, 'N/A', data[d].description]
                    exportData.push( subData );
                  }
                }
              }
              if( data[d].product_codes.length > 0 ) {
                for( var dc in data[d].product_codes ) {
                  if( data[d].product_codes[dc].value != '' ) {

                    var department = 'N/A';
                    if( pcLinks[data[d].product_codes[dc].value] ) {
                      department = pcLinks[data[d].product_codes[dc].value];
                    }
                    var subData = [data[d].name, department, 'N/A', data[d].product_codes[dc].value, data[d].description]
                    exportData.push( subData );
                  }
                }
              }
            }
          }
          dispatch('fncReturnExcelVendor', exportData);
        });
    });
};

export const fncPopulateManufacturerAudits = ({ commit, dispatch, state, rootState }, payload) => {

    var objAuth = JSON.parse(rootState.objAuthorize);
    var quoteDetails = { a: 'getManufacturerAudits', manufacturer: objAuth.manufacturer };
    Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php', { params: quoteDetails }, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        console.log(error);
      }).then(data => {
        commit('fncSetManufacturerAudits', data);
    });

};

export const fncAddVendor = ({ commit, dispatch, state, rootState }, payload) => {

	var vendorRanges = [];
	var vendorRangeNames = [];

	for (var r in payload.vendorDetails.vendorRanges) {
		var range = { id: payload.vendorDetails.vendorRanges[r].id32, name: payload.vendorDetails.vendorRanges[r].name, headName: payload.vendorDetails.vendorRanges[r].headName };
		vendorRanges.push(range);
	}

	var objAuth = JSON.parse(rootState.objAuthorize);
	var vendorDetails = {
		name: payload.vendorDetails.vendorName,
		description: payload.vendorDetails.vendorDescription,
		address: payload.vendorDetails.vendorAddress,
		current_user_id: objAuth.id,
		current_user_manu: objAuth.manufacturer,
		email: payload.vendorDetails.vendorEmail,
		linked_manufacturer: payload.vendorDetails.vendorManufacturer,
		ranges: vendorRanges,
		pdf: JSON.stringify(payload.vendorDetails.vendorPdf),
    product_codes: payload.vendorDetails.vendorProductCodes,
    branches_departments: JSON.stringify(payload.vendorDetails.branchesDepartments)
	}
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php?a=create', vendorDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'The vendor could not be added, please try again', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {
			var snackDetails = { color: 'success', message: 'The vendor was added successfully', display: true };
			commit('hideModal');
			commit('setSnack', snackDetails);
			/*dispatch({
				type: 'fncPopulateVendors',
				refresh: true
			})*/
			commit('setRunAdd', false);
    setTimeout(function(){
      location.reload();
    }, 1000)
		});
};

export const fncEditvendor = ({ commit, dispatch, state, rootState }, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);
	var vendorDetails = {
		name: state.objVendorEdit.name,
		address: state.objVendorEdit.address,
		description: state.objVendorEdit.description,
		id: state.objVendorEdit.id,
		linked_manufacturer: state.objVendorEdit.manufacturer,
		email: state.objVendorEdit.email,
		ranges: state.objVendorEdit.savedRanges,
    pdf: JSON.stringify(state.objVendorEdit.pdf_settings),
    current_user_manu: objAuth.manufacturer,
    product_codes: state.objVendorEdit.product_codes,
    branchesDepartments: JSON.stringify(payload)
	}

	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php?a=update', vendorDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'The vendor could not be updated, please try again', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {
			var snackDetails = { color: 'success', message: 'The vendor was updated successfully', display: true };
			commit('hideModal');
			commit('setSnack', snackDetails);
			/*dispatch({
				type: 'fncPopulateVendors',
				refresh: true
			})*/
			commit('setRunAdd', false);
			setTimeout(function(){
        location.reload();
      }, 1000)
		});

};

export const fncVendorDelete = ({ commit, dispatch, state, rootState }, payload) => {
	var vendorDetails = { id: payload.vendorId }
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php?a=delete', vendorDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'The vendor could not be removed, please try again', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {
			var snackDetails = { color: 'success', message: 'The vendor was removed successfully', display: true };
			commit('setSnack', snackDetails);
			dispatch({
				type: 'fncPopulateVendors',
				refresh: true
			})
		});
}

export const fncPopulateManufacturers = ({ commit, dispatch, state, rootState }, payload) => {

	var objAuth = JSON.parse(rootState.objAuthorize);
	Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error has occured', display: true };
			commit('setSnack', snackDetails);
			console.log(error);
		}).then(data => {
			var tokenDetails = { token: data.token };
			Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/manufacturers', { params: tokenDetails }, rootState.headerDetails)
				.then(response => {
					return response.json();
				}, error => {
					var snackDetails = { color: 'error', message: 'An error has occured', display: true };
					commit('setSnack', snackDetails);
					console.log(error);
				}).then(dt => {

					var modalDetails = { title: 'Add Vendor', component: 'modal-vendor-add', mstate: true, params: {} };
					commit({
						type: 'setModal',
						details: modalDetails
					});
					commit('fncSetVendorManufacturers', dt);
				});
		});

}

export const fncGetManufacturerRanges = ({ commit, dispatch, state, rootState }, payload) => {

	var objAuth = JSON.parse(rootState.objAuthorize);
	Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error has occured', display: true };
			commit('setSnack', snackDetails);
			console.log(error);
		}).then(data => {
			var rangeDetails = { token: data.token, manufacturer_key: payload.id, published_status: 1, use_app_name: 0 };
			Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/ranges', { params: rangeDetails }, rootState.headerDetails)
				.then(response => {
					return response.json();
				}, error => {
					var snackDetails = { color: 'error', message: 'An error has occured', display: true };
					commit('setSnack', snackDetails);
					console.log(error);
				}).then(d => {
					commit({
						type: 'fncSetManufacturerRanges',
						ranges: d,
                        name: payload.name
					})
				});
		});
}

export const fncSetVendorEdit = ({ commit, dispatch, state, rootState }, payload) => {

	var objAuth = JSON.parse(rootState.objAuthorize);
	Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error has occured', display: true };
			commit('setSnack', snackDetails);
			console.log(error);
		}).then(data => {
			var tokenDetails = { token: data.token };
			Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/manufacturers', { params: tokenDetails }, rootState.headerDetails)
				.then(response => {
					return response.json();
				}, error => {
					var snackDetails = { color: 'error', message: 'An error has occured', display: true };
					commit('setSnack', snackDetails);
					console.log(error);
				}).then(dt => {

         commit('fncSetVendorManufacturers', dt);
          commit({
            type: 'objVendorEdit',
            vendor: payload.vendor
          })

        var vendorDetails = { vendor: payload.vendor.id };
        Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php?a=getVendorDepartmentBranches', vendorDetails, rootState.headerDetails)
          .then(response => {
            return response.json();
          }, error => {
            console.log(error);
          }).then(vsd => {

          var modalDetails = { title: 'Edit Vendor - ' + payload.vendor_name, component: 'modal-vendor-edit', mstate: true, params: { branchDepartments: vsd } };
          commit({
            type: 'setModal',
            details: modalDetails
          });
          commit('setIsLoading', false);

        });
        /*var modalDetails = { title: 'Edit Vendor - ' + payload.vendor_name, component: 'modal-vendor-edit', mstate: true };
          commit({
            type: 'setModal',
            details: modalDetails
          });
          commit('setIsLoading', false);*/


					/*var rangeDetails = { token: data.token, published_status: 1, use_app_name: 0 };

					Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/ranges', { params: rangeDetails }, rootState.headerDetails)
						.then(response => {
							return response.json();
						}, error => {
							var snackDetails = { color: 'error', message: 'An error has occured', display: true };
							commit('setSnack', snackDetails);
							console.log(error);
						}).then(d => {

							for ( var m in dt ) {
								dt[m].id = parseInt(dt[m].id);
							}
							commit('fncSetVendorManufacturers', dt);
							commit('fncSetManufacturerRanges', d);
							commit({
								type: 'objVendorEdit',
								vendor: payload.vendor,
                                spineRanges: d
							})
			                var modalDetails = { title: 'Edit Vendor - ' + payload.vendor_name, component: 'modal-vendor-edit', mstate: true };
			                commit({
				                type: 'setModal',
				                details: modalDetails
			                });
							commit('setIsLoading', false);
						});*/
				});
		});
}

/*export const fncSetVendorEdit = ({ commit, dispatch, state, rootState }, payload) => {

  var objAuth = JSON.parse(rootState.objAuthorize);
  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured', display: true };
      commit('setSnack', snackDetails);
      console.log(error);
    }).then(data => {
    var tokenDetails = { token: data.token };
    Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/manufacturers', { params: tokenDetails }, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error has occured', display: true };
        commit('setSnack', snackDetails);
        console.log(error);
      }).then(dt => {

      var rangeDetails = { token: data.token, published_status: 1, use_app_name: 0 };

      Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/ranges', { params: rangeDetails }, rootState.headerDetails)
        .then(response => {
          return response.json();
        }, error => {
          var snackDetails = { color: 'error', message: 'An error has occured', display: true };
          commit('setSnack', snackDetails);
          console.log(error);
        }).then(d => {

        for ( var m in dt ) {
          dt[m].id = parseInt(dt[m].id);
        }
        commit('fncSetVendorManufacturers', dt);
        commit('fncSetManufacturerRanges', d);
        commit({
          type: 'objVendorEdit',
          vendor: payload.vendor,
          spineRanges: d
        })
        var modalDetails = { title: 'Edit Vendor - ' + payload.vendor_name, component: 'modal-vendor-edit', mstate: true };
        commit({
          type: 'setModal',
          details: modalDetails
        });
        commit('setIsLoading', false);
      });
    });
  });
}*/

export const fncSelectVendor = ({ commit, dispatch, state, rootState }, payload) => {

	var objAuth = JSON.parse(rootState.objAuthorize);
	var vendorDetails = {
		vendor: payload.vendor.id,
		reference: payload.reference,
		current_user_id: objAuth.id,
		current_manufacturer: objAuth.manufacturer
	}

	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php?a=linkVendor', vendorDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'The vendor could not be selected, please try again', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {
			var snackDetails = { color: 'success', message: 'The vendor was selected successfully', display: true };
			commit('hideModal');
			commit('setSnack', snackDetails);
			dispatch({
				type: 'fncPopulateVendorLinks',
				refresh: true
			})
			commit('setRunAdd', false);
		});
}

export const fncPopulateVendorLinks = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var vendorDetails = { manufacturer: objAuth.manufacturer  };
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php?a=getManufacturerVendors', vendorDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
			commit('fncSetManufacturerVendors', data);
		});
}

export const fncPopulateVendorLinksNotifications = ({ commit, dispatch, state, rootState }, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var vendorDetails = { manufacturer: objAuth.manufacturer  };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php?a=getManufacturerVendorsNotifications', vendorDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
    commit('fncSetManufacturerVendors', data);
  });
}

export const fncRemoveVendorLink = ({ commit, dispatch, state, rootState }, payload) => {

	var vendorDetails = { linkId: payload.linkId };
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php?a=removeVendorLink', vendorDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
			var snackDetails = { color: 'success', message: 'The vendor link was removed successfully', display: true };
			commit('hideModal');
			commit('setSnack', snackDetails);
			dispatch({
				type: 'fncPopulateVendorLinks',
				refresh: true
			})
			commit('setRunAdd', false);
		});
}

export const fncSetVendorSelectEdit = ({ commit, dispatch, state, rootState }, payload) => {
	commit('fncSetVendorSelectEdit', payload.objVendor);
	var modalDetails = { title: 'Edit Vendor Select - ' + payload.vendorName, component: 'modal-vendor-select-edit', mstate: true, params: {} };
	commit({
		type: 'setModal',
		details: modalDetails
	});
}

export const fncUpdateSelectVendor = ({ commit, dispatch, state, rootState }, payload) => {

	var vendorDetails = { id: state.objVendorSelectEdit.id, vendor: state.objVendorSelectEdit.vendorId, reference: state.objVendorSelectEdit.reference };

	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php?a=editVendorLink', vendorDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
			var snackDetails = { color: 'success', message: 'The vendor link was updated successfully', display: true };
			commit('hideModal');
			commit('setSnack', snackDetails);
			dispatch({
				type: 'fncPopulateVendorLinks',
				refresh: true
			})
			commit('setRunAdd', false);
		});
}

export const fncGetAppRanges = ({ commit, dispatch, state, rootState }, payload) => {

	var objAuth = JSON.parse(rootState.objAuthorize);
	Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error has occured', display: true };
			commit('setSnack', snackDetails);
			console.log(error);
		}).then(data => {
			var rangeDetails = { token: data.token, manufacturer_key: objAuth.manufacturer, published_status: 1, use_app_name: 0 };
			Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/ranges', { params: rangeDetails }, rootState.headerDetails)
				.then(response => {
					return response.json();
				}, error => {
					var snackDetails = { color: 'error', message: 'An error has occured', display: true };
					commit('setSnack', snackDetails);
					console.log(error);
				}).then(d => {
					setTimeout(function () {
					  commit({
              type: 'fncSetupAssign',
              vendors: d,
              manufacturer: objAuth.manufacturer
            });
						// commit('fncSetupAssign', d);
					}, 2000);
				});
		});
}

export const fncVendorSaveData = ({ commit, dispatch, state, rootState }, payload) => {

	var objAuth = JSON.parse(rootState.objAuthorize);
	var vendorDetails = { vendors: state.vendorManufacturerLinks, manufacturer: objAuth.manufacturer };

	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php?a=updateVendors', vendorDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {

			var snackDetails = { color: 'success', message: 'The vendor link was updated successfully', display: true };
			commit('setSnack', snackDetails);
			commit('setRunAdd', false);
		});
}

export const fncIniVendors = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var vendorDetails = { vendors: state.vendorManufacturerLinks, manufacturer: objAuth.manufacturer };
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php?a=updateVendors', vendorDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
			var snackDetails = { color: 'success', message: 'The vendor layer has been iniated', display: true };
			commit('setSnack', snackDetails);
			commit('setRunAdd', false);
			commit('fncSetIni');
		});
}

export const fncVendorDepartmentBranches = ({ commit, dispatch, state, rootState }, payload) => {
  var vendorDetails = { vendor: payload };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php?a=getVendorDepartmentBranches', vendorDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
      console.log('DATA');
      console.log(data);
      commit('fncSetVendorDepartmentBranches', data);
    /*var snackDetails = { color: 'success', message: 'The vendor layer has been iniated', display: true };
    commit('setSnack', snackDetails);
    commit('setRunAdd', false);
    commit('fncSetIni');*/
  });
}

export const fncGetManualInstallations = ({ commit, dispatch, state, rootState }, payload) => {
  var manufacturerDetails = {manufacturer: payload};
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getManualInstallations', manufacturerDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

      if( data != '' && data != 'null' ) {
        commit('setManualInstallations', data);
      }

  });
}
